import React, { useState } from "react";
import "./css.css";
import { useUser } from "reactfire";
import { Link } from "react-router-dom";
import AddProduct from "../AddProduct";
import "firebase/auth";
import firebase from "firebase/app";

export default function Admin() {
  const [page, setPage] = useState("");
  const handleChangePage = (e) => {
    setPage(e.target.name);
  };

  const handleLogOut = () => {
    firebase.auth().signOut();
  };

  if (useUser()) {
    if (page === "addProd")
      return <AddProduct handleChangePage={handleChangePage} />;
    else
      return (
        <div className="content-admin">
          <button className="button" onClick={handleLogOut}>
            Cerrar sesión
          </button>
          <h3>Iniciado como Administrador</h3>
          <Link className="button" to="/admin/addProduct">
            Agregar Producto
          </Link>
          <Link className="button" to="/admin/scanner">
            Listado scanner
          </Link>
        </div>
      );
  } else {
    return <div></div>;
  }
}
